<template>
  <div id="AboutUs">
    <Header />
    <div class="area1">
      <img class="bg-img" src="@/assets/img/aboutus/aboutus_bg.png" alt="SURREAL 超現實科技" />
      <div class="content-area">
        <h1 class="content-title">關於超現實科技</h1>
        <div class="split-line"></div>
        <h3 class="content-desc">
          超現實科技股份有限公司成立於2016年，我們走在VR創新內容研發的浪尖上，致力於透過虛擬實境來打造全新的學習型態，以身歷其境的互動體驗推出即時雙向式教學應用平台及教育服務，期望能藉由VR科技突破現實的框架、共創共學。我們本著的創新精神和豐富的產業服務經驗，亦提供企業品牌高效率、高品質的數位科技互動整合方案，亦步亦趨地協助客戶打造品牌，創造顛覆以往的數位新生活。
        </h3>
      </div>
    </div>
    <div class="area2">
      <div class="content-area">
        <h1 class="content-title">認識我們的團隊</h1>
        <div class="split-line"></div>
        <h3 class="content-desc">
          團隊著重創新數位行銷、虛擬科技、人機互動、使用者經驗設計與研究等，我們致力於打破傳統框架將虛擬世界帶入現實體驗，一同創新思考突破挑戰。
        </h3>
        <div class="team-area">
          <div class="team-item" v-for="item in Teams" :key="item.TeamName">
            <img class="team-img" :src="item.ImgUrl" :alt="item.TeamName" />
            <div class="team-name">{{ item.TeamName }}</div>
            <div class="team-desc">{{ item.TeamDesc }}</div>
          </div>
          <div class="clear-both"></div>
        </div>
      </div>
    </div>
    <div class="area3">
      <div class="content-area">
        <h1 class="content-title">合作夥伴</h1>
        <div class="split-line"></div>
        <h2 class="content-subtitle">Educations 教育</h2>
        <div class="partner-area">
          <img
            class="partner-img"
            v-for="item in Edu"
            :key="item.Name"
            :src="item.UrlPath"
            :alt="item.Name"
            @click="LinkPartner(item.Url)"
          />
          <div class="clear-both"></div>
        </div>
        <h2 class="content-subtitle">Industries 產業</h2>
        <div class="partner-area">
          <img
            class="partner-img"
            v-for="item in Ind"
            :key="item.Name"
            :src="item.UrlPath"
            :alt="item.Name"
            @click="LinkPartner(item.Url)"
          />
          <div class="clear-both"></div>
        </div>
        <h2 class="content-subtitle">Officials 官方</h2>
        <div class="partner-area">
          <img
            class="partner-img"
            v-for="item in Official"
            :key="item.Name"
            :src="item.UrlPath"
            :alt="item.Name"
            @click="LinkPartner(item.Url)"
          />
          <div class="clear-both"></div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';
import AOS from 'aos';
import 'aos/dist/aos.css';
export default {
  mounted() {
    AOS.init();
    this.GetTeamInfo();
    this.GetPartner();
  },
  data() {
    return {
      SEOTitle: 'About US 關於超現實科技',
      SEODesc:
        'SURREAL 超現實科技以創新精神走在新科技研發的浪尖上，致力於打造全新的學習型態，以提供身歷其境的互動體驗為目標。秉持高效率、高品質、高度貼近真實需求，創造顛覆以往的數位新生活。',
      AOS: {
        Offset: '270',
        Dur: '1200',
      },
      Teams: [],
      Edu: [],
      Ind: [],
      Official: [],
    };
  },
  metaInfo() {
    return {
      title: this.SEOTitle,
      meta: [
        {
          name: 'description',
          content: this.SEODesc,
        },
      ],
    };
  },
  computed: {},
  methods: {
    GetTeamInfo() {
      this.Teams = [
        {
          ImgUrl: require('@/assets/img/aboutus/dept_1_prod.png'),
          TeamName: '​產品研發部',
          TeamDesc:
            '根據使用者需求、情境和內外部Stakeholder目標規劃產品路線圖，負責市場研究、產品定位，進行新產品或新功能的構想企劃、概念設計及制定產品定價。',
        },
        {
          ImgUrl: require('@/assets/img/aboutus/dept_2_code.png'),
          TeamName: '軟體研發部',
          TeamDesc:
            '研發軟體新技術與新工具，並與產品研發部緊密合作，進行新產品或功能的後期開發流程，另依各項專案需求進行程式開發、軟體設計進度控管。',
        },
        {
          ImgUrl: require('@/assets/img/aboutus/dept_3_3d.png'),
          TeamName: '互動設計部',
          TeamDesc: '負責互動設計創意發想提案，並依不同產品風格及專案需求打造專屬3D場景、人物角色及物件等製作。',
        },
        {
          ImgUrl: require('@/assets/img/aboutus/dept_4_2d.png'),
          TeamName: '創意設計部',
          TeamDesc: '負責各項視覺設計創意發想及UI/UX介面規劃，包含網頁、手機App、AR/VR互動科技、平面印刷設計等。',
        },
        {
          ImgUrl: require('@/assets/img/aboutus/dept_5_market.png'),
          TeamName: '市場行銷部',
          TeamDesc:
            '偕同產品研發部進行前期市場研究、使用者樣貌分析，制定及管理產品上市規劃、品牌/產品年度行銷計畫，設定各項行銷活動的KPI，協助相關人員進行教育訓練及經銷商培訓。',
        },
        {
          ImgUrl: require('@/assets/img/aboutus/dept_6_sales1.png'),
          TeamName: '產品業務部',
          TeamDesc:
            '熟悉政府標案，負責與教育供應商合作開發、關係經營，並根據教育市場的需求，提供各項完整VR教育產品與服務。',
        },
        {
          ImgUrl: require('@/assets/img/aboutus/dept_7_sales2.png'),
          TeamName: '​專案業務部',
          TeamDesc:
            '透過視覺設計、軟體互動、硬體規劃，將科技數位運算與IT硬體產業結合，為客戶量身打造互動行銷方案，及提供跨領域的技術整合服務。',
        },
      ];
    },
    GetPartner() {
      //改的頻率不高 不做API了
      this.Edu = [
        {
          Name: 'Live ABC',
          Url: 'https://store.liveabc.com/',
          UrlPath: require('@/assets/img/aboutus/edu_1.png'),
        },
        {
          Name: 'ZA Share 雜學校',
          Url: 'https://zashare.org/',
          UrlPath: require('@/assets/img/aboutus/edu_2.png'),
        },
        {
          Name: '親子天下',
          Url: 'https://www.parenting.com.tw/',
          UrlPath: require('@/assets/img/aboutus/edu_3.png'),
        },
        {
          Name: '仁愛自造教育中心',
          Url: 'https://www.facebook.com/RenAiMaker/',
          UrlPath: require('@/assets/img/aboutus/edu_4.jpg'),
        },
        {
          Name: '卡爾國際實驗學校',
          Url: 'https://www.karlschool.org/',
          UrlPath: require('@/assets/img/aboutus/edu_5.jpg'),
        },
        {
          Name: '台北市永春高中',
          Url: 'https://www.ycsh.tp.edu.tw/bin/home.php',
          UrlPath: require('@/assets/img/aboutus/edu_6.png'),
        },
      ];
      this.Ind = [
        {
          Name: 'Startup Island TAIWAN',
          Url: 'https://www.startupislandtaiwan.info/',
          UrlPath: require('@/assets/img/aboutus/ind_1.png'),
        },
        {
          Name: 'Lenovo',
          Url: 'https://www.lenovo.com/tw/zh',
          UrlPath: require('@/assets/img/aboutus/ind_2.png'),
        },
        {
          Name: '遠傳電信 FET',
          Url: 'https://www.fetnet.net/content/cbu/tw/index.html',
          UrlPath: require('@/assets/img/aboutus/ind_3.png'),
        },
        {
          Name: 'SYNNEX',
          Url: 'https://www.synnex-grp.com/tw',
          UrlPath: require('@/assets/img/aboutus/ind_4.png'),
        },
        {
          Name: '中華電信',
          Url: 'https://www.cht.com.tw/home/consumer',
          UrlPath: require('@/assets/img/aboutus/ind_5.jpg'),
        },
        {
          Name: 'HR人資小周末',
          Url: 'https://hrfriday.com.tw/',
          UrlPath: require('@/assets/img/aboutus/ind_6.png'),
        },
        {
          Name: 'TAVAR',
          Url: 'https://www.tavar.tw/news.aspx',
          UrlPath: require('@/assets/img/aboutus/ind_7.png'),
        },
        {
          Name: 'BoostVC',
          Url: 'https://www.boost.vc/',
          UrlPath: require('@/assets/img/aboutus/ind_8.png'),
        },
        {
          Name: '哈佛管顧',
          Url: 'https://www.harment.com/',
          UrlPath: require('@/assets/img/aboutus/ind_9.png'),
        },
        {
          Name: 'VIVE',
          Url: 'https://www.vive.com/tw/',
          UrlPath: require('@/assets/img/aboutus/ind_10.png'),
        },
        {
          Name: 'ACER',
          Url: 'https://www.acer.com/ac/zh/TW/content/home',
          UrlPath: require('@/assets/img/aboutus/ind_11.png'),
        },
        {
          Name: 'XR EXPRESS TW',
          Url: 'https://www.xrexpress.tw/',
          UrlPath: require('@/assets/img/aboutus/ind_12.png'),
        },
        {
          Name: 'Qualcomm',
          Url: 'https://www.qualcomm.com/',
          UrlPath: require('@/assets/img/aboutus/ind_13.jpg'),
        },
      ];
      this.Official = [
        {
          Name: '國家發展委員會',
          Url: 'https://www.ndc.gov.tw/',
          UrlPath: require('@/assets/img/aboutus/officals_1.png'),
        },
        {
          Name: '教育部全球資訊網',
          Url: 'https://www.edu.tw/Default.aspx',
          UrlPath: require('@/assets/img/aboutus/officals_2.png'),
        },
        {
          Name: '台北市政府',
          Url: 'https://www.gov.taipei/',
          UrlPath: require('@/assets/img/aboutus/officals_3.png'),
        },
        {
          Name: '高雄市政府教育局',
          Url: 'https://www.kh.edu.tw/',
          UrlPath: require('@/assets/img/aboutus/officals_4.png'),
        },
        {
          Name: '新竹縣教網中心',
          Url: 'https://www.hcc.edu.tw/',
          UrlPath: require('@/assets/img/aboutus/officals_5.png'),
        },
        {
          Name: '國立台灣大學師資培育中心',
          Url: 'http://www.education.ntu.edu.tw/index.htm',
          UrlPath: require('@/assets/img/aboutus/officals_6.jpg'),
        },
        {
          Name: 'TAICCA 文化內容策進院',
          Url: 'https://taicca.tw/',
          UrlPath: require('@/assets/img/aboutus/officals_7.png'),
        },
      ];
    },
    LinkPartner(Url) {
      window.open(Url, '_blank').focus();
    },
  },
  components: { Header, Footer },
};
</script>
